import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Field } from 'formik';
import { Drawer } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import CustomTextField from './TextField';
import CustomDateField from './DateField';
import FindCompany from '../pages/drawers/FindCompany';
import CustomFindField from './FindField';
import helpers from '../../../utils/helpers';

const FieldsLinesStrip = ({ formikBag, loading }) => {

  const subSystems = useSelector(state => state.vehicle.subSystems);
  const vehicleType = useSelector(state => state.vehicle.vehicleType);
  const lineGrants = useSelector(state => state.line.grants);
  const lineServices = useSelector(state => state.line.services);
  const vehicleClassification = useSelector(state => state.vehicle.vehicleClassification);
  const orgaos = useSelector(state => state.forms.orgaos);
  const selectedLine = useSelector(state => state.line.selected);

  const [openDrawer, setOpenDrawer] = useState(false);

  useEffect(() => {
    (() => {
      if(selectedLine && selectedLine.empresa){
        formikBag.setFieldValue('cdEmpresa', selectedLine.empresa.cdEmpresa);
        formikBag.setFieldValue('deRazaoSocial', selectedLine.empresa.deRazaoSocial);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[selectedLine]);

  const handleSetSelectedList = (data) => {
    formikBag.setFieldValue('cdEmpresa', data.cdEmpresa);
    formikBag.setFieldValue('deRazaoSocial', data.deRazaoSocial);
  };

  return (
    <>
      <Grid item xs={12} sm={6}>
        <Field
          component={CustomFindField}
          name='deRazaoSocial'
          label='Empresa'
          onClickButton={() => setOpenDrawer(true)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Field
          component={CustomTextField}
          label='Outorga'
          name='cdLinhaOutorga'
          select
          loading={loading}
          SelectProps={{
            native: true,
          }}
        >
          <option aria-label='None' value=''>
            Selecione
          </option>
          {helpers.ordernarArray({ data: lineGrants, field: 'deLinhaOutorga' })?.map((entry, index) => {
            return (
              <option key={`out-${index}`} value={entry.cdLinhaOutorga}>
                {entry.deLinhaOutorga}
              </option>
            );
          })}
        </Field>
      </Grid>

      <Grid item xs={12} sm={6}>
        <Field
          component={CustomTextField}
          label='Nº Contrato/Termo'
          name='nuTermoContrato'
          inputProps={{
            maxLength: 10,
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Field
          component={CustomDateField}
          label='Data Contrato/Termo'
          name='dtTermoContrato'
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <Field
          component={CustomTextField}
          label='Orgão Contrato/Termo'
          name='cdOrgaoTermoContrato'
          select
          loading={loading}
          SelectProps={{
            native: true,
          }}
        >
          <option aria-label='None' value=''>
            Selecione
          </option>
          {orgaos?.map((entry, index) => {
            return (
              <option key={`age-${index}`} value={entry.cdOrgao}>
                {entry.sgOrgao}
              </option>
            );
          })}
        </Field>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Field
          component={CustomTextField}
          label='Serviço'
          name='cdLinhaServico'
          select
          loading={loading}
          SelectProps={{
            native: true,
          }}
        >
          <option aria-label='None' value=''>
            Selecione
          </option>
          {helpers.ordernarArray({ data: lineServices, field: 'deLinhaServico' })?.map((entry, index) => {
            return (
              <option key={`service-${index}`} value={entry.cdLinhaServico}>
                {entry.deLinhaServico}
              </option>
            );
          })}
        </Field>
      </Grid>

      <Grid item xs={12} sm={6}>
        <Field
          component={CustomTextField}
          label='Categoria'
          name='cdCategoria'
          select
          loading={loading}
          SelectProps={{
            native: true,
          }}
        >
          <option aria-label='None' value=''>
            Selecione
          </option>
          {helpers.ordernarArray({ data: vehicleClassification, field: 'sgSlassificacaoVeiculo' })?.map((entry, index) => {
            return (
              <option key={`cat-${index}`} value={entry.cdClassificacaoVeiculo}>
                {entry.sgSlassificacaoVeiculo} - {entry.deClassificacaoVeiculo}
              </option>
            );
          })}
        </Field>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Field
          component={CustomTextField}
          label='Tipo de veículo'
          name='cdTipoVeiculo'
          select
          loading={loading}
          SelectProps={{
            native: true,
          }}
        >
          <option aria-label='None' value=''>
            Selecione
          </option>
            {helpers.ordernarArray({ data: vehicleType, field: 'deTipoVeiculo' })?.map((entry, index) => {
            return (
              <option key={`vehitype-${index}`} value={entry.cdTipoVeiculo}>
                {entry.deTipoVeiculo}
              </option>
            );
          })}
        </Field>
      </Grid>

      <Grid item xs={12} sm={6}>
        <Field
          component={CustomTextField}
          label='Subsistema'
          name='cdSubSistema'
          select
          loading={loading}
          SelectProps={{
            native: true,
          }}
        >
          <option aria-label='None' value=''>
            Selecione
          </option>
          {helpers.ordernarArray({ data: subSystems, field: 'deSubSistema' })?.filter(entry => {
            return !entry.boComplementar && entry.deUtilizacao === 'Sistema';
          }).map((type, index) => {
            return (
              <option key={`sub-${index}`} value={type.cdSubSistema}>
                {type.deSubSistema}
              </option>
            );
          })}
        </Field>
      </Grid>

      <Drawer
        anchor='right'
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
      >
        <FindCompany
          onClose={() => setOpenDrawer(false)}
          onSave={handleSetSelectedList}
          requestParams={{ tipoGeral: true }}
        />
      </Drawer>
    </>
  );
};

export default FieldsLinesStrip;